import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import lotteryIcon from 'assets/dashboard/lottery.png';
import LotteryUploadCsvDashboard from './lotteryUploadCsv';
import LotteryActionsDashboard from './lotteryActions';

export const LOTTERY_RESOURCES = {
	lotteryActions: 'lotteryActions',
	uploadCsv: 'uploadCsv'
};

export const URL = {
	[LOTTERY_RESOURCES.lotteryActions]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.lottery}/${LOTTERY_RESOURCES.lotteryActions}`,
	[LOTTERY_RESOURCES.uploadCsv]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.lottery}/${LOTTERY_RESOURCES.uploadCsv}`
};

export const LABEL = {
	[LOTTERY_RESOURCES.lotteryActions]: 'Lottery Actions',
	[LOTTERY_RESOURCES.uploadCsv]: 'Upload CSV'
};

export const COMPONENT = {
	[LOTTERY_RESOURCES.uploadCsv]: LotteryUploadCsvDashboard,
	[LOTTERY_RESOURCES.lotteryActions]: LotteryActionsDashboard
};

export const CONFIG_RESOURCE = {
	[LOTTERY_RESOURCES.lotteryActions]: 'Lottery Actions',
	[LOTTERY_RESOURCES.uploadCsv]: 'Upload CSV'
};

export const GET_ACTION = {
	[LOTTERY_RESOURCES.lotteryActions]: 'getLotteryActions',
	[LOTTERY_RESOURCES.uploadCsv]: 'getUploadCsvPage'
};

export const IMAGE_SOURCE = {
	[LOTTERY_RESOURCES.lotteryActions]: lotteryIcon,
	[LOTTERY_RESOURCES.uploadCsv]: lotteryIcon
};
